import React from 'react';
import './Switch.css';

export function Switch(
   props: Readonly<{
      checked: any;
      onChange?: (checked: boolean) => void;
   }>
) {
   const { checked, onChange } = props;

   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
         onChange(event.target.checked);
      }
   };

   return (
      <div className="switch-component">
         <label className="switch">
            <input
               type="checkbox"
               checked={checked}
               onChange={handleChange}
            />
            <span className="slider round"></span>
         </label>
      </div>
   );
}
